<template>
  <div class="summary-sticky">
    <b-card class="summary-card shadow-sm">
      <h6 class="section-label mt-0">
        <feather-icon icon="ClipboardIcon" size="13" class="mr-50" />Summary
      </h6>

      <div class="summary-list">
        <div class="summary-row">
          <span>Transfer Fee <small class="text-muted">(2%)</small></span>
          <strong>฿ {{ formatNumber(result.transferFee) }}</strong>
        </div>
        <div class="summary-row">
          <span>
            {{ result.sbtOrStampDuty.type === 'sbt' ? 'Specific Business Tax' : 'Stamp Duty' }}
            <small class="text-muted">({{ result.sbtOrStampDuty.type === 'sbt' ? '3.3%' : '0.5%' }})</small>
          </span>
          <strong>฿ {{ formatNumber(result.sbtOrStampDuty.amount) }}</strong>
        </div>
        <div class="summary-row">
          <span>Withholding Tax</span>
          <strong>฿ {{ formatNumber(result.withholdingTax) }}</strong>
        </div>
        <div class="summary-row summary-row--total bg-light-primary rounded">
          <span class="text-primary font-weight-bold">Tax Total</span>
          <strong class="text-primary">฿ {{ formatNumber(result.total) }}</strong>
        </div>
      </div>

      <hr />

      <div class="summary-list">
        <div class="summary-row">
          <span>
            Commission
            <small class="text-muted">
              ({{ commissionType === 'manual' ? 'manual' : (formatNumber(commissionRate) || 0) + '%' }})
            </small>
          </span>
          <strong>฿ {{ formatNumber(commissionResult.commission) }}</strong>
        </div>
        <div v-if="commissionIncludeVat" class="summary-row">
          <span>VAT <small class="text-muted">(7%)</small></span>
          <strong>฿ {{ formatNumber(commissionResult.vat) }}</strong>
        </div>
        <div class="summary-row summary-row--total bg-light-info rounded">
          <span class="text-info font-weight-bold">Commission Total</span>
          <strong class="text-info">฿ {{ formatNumber(commissionResult.total) }}</strong>
        </div>
      </div>

      <hr />

      <div class="split-totals mb-0">
        <div class="split-total-box bg-light-primary rounded">
          <span class="text-muted d-block mb-25">
            <feather-icon icon="UserIcon" size="13" class="mr-25" />Buyer Total
          </span>
          <strong class="text-primary">฿ {{ formatNumber(buyerTotal) }}</strong>
        </div>
        <div class="split-total-box bg-light-info rounded">
          <span class="text-muted d-block mb-25">
            <feather-icon icon="UserIcon" size="13" class="mr-25" />Seller Total
          </span>
          <strong class="text-info">฿ {{ formatNumber(sellerTotal) }}</strong>
        </div>
      </div>

      <hr />

      <div class="summary-list">
        <div class="summary-row">
          <span>Total Deductions</span>
          <strong>฿ {{ formatNumber(sellerDeductionsTotal) }}</strong>
        </div>
        <div class="summary-row summary-row--total bg-light-success rounded">
          <span class="text-success font-weight-bold">Net to Seller</span>
          <strong class="text-success">฿ {{ formatNumber(sellerNetChequeTotal) }}</strong>
        </div>
      </div>

      <hr />

      <b-button
        block
        variant="outline-primary"
        class="mb-50"
        :disabled="preparingExpensePdf"
        @click="$emit('download-expense-pdf')"
      >
        {{ preparingExpensePdf ? 'Preparing...' : 'Download Summary (PDF)' }}
      </b-button>
      <b-button
        block
        variant="outline-info"
        class="mb-50"
        :disabled="preparingClosingPdf"
        @click="$emit('download-closing-pdf')"
      >
        {{ preparingClosingPdf ? 'Preparing...' : 'Download Closing Statement (PDF)' }}
      </b-button>
      <b-button block variant="primary" class="mb-0" :disabled="isSaving" @click="$emit('save')">
        {{ isSaving ? 'Saving...' : 'Save' }}
      </b-button>
    </b-card>
  </div>
</template>

<script>
import { BCard, BButton } from 'bootstrap-vue'
import { formatNumber } from '../format'

export default {
  components: { BCard, BButton },
  props: {
    result: { type: Object, required: true },
    commissionType: { type: String, required: true },
    commissionRate: { type: Number, default: null },
    commissionResult: { type: Object, required: true },
    commissionIncludeVat: { type: Boolean, default: true },
    buyerTotal: { type: Number, default: 0 },
    sellerTotal: { type: Number, default: 0 },
    sellerDeductionsTotal: { type: Number, default: 0 },
    sellerNetChequeTotal: { type: Number, default: 0 },
    preparingExpensePdf: { type: Boolean, default: false },
    preparingClosingPdf: { type: Boolean, default: false },
    isSaving: { type: Boolean, default: false },
  },
  methods: {
    formatNumber,
  },
}
</script>
